import { Trans } from '@lingui/react/macro';

import Stack from '@/design_system/Stack';
import Paragraph from '@/design_system/Typography/Paragraph';
import { BrandRequestMainContent } from '@/layouts/Brand/BrandRequestLayout/BrandRequestLayout';
import { RequestWithRelations } from '@/models/request';
import { ClientArticlesList } from '@/routes/Brand/Requests/Request/components/shared/ClientArticlesList';
import ClientStepper from '@/routes/Brand/Requests/Request/components/shared/ClientStepper';
import { PickupPointInfo } from '@/routes/Brand/Requests/Request/components/shared/PickupPointInfo/PickupPointInfo';
import useViewPort from '@/utils/useViewport';

import { StepMessage } from '../../shared/StepMessage';

const Exchange = ({ request }: { request: RequestWithRelations }) => {
  const { isMobile } = useViewPort();

  return (
    <BrandRequestMainContent>
      <Stack gap="1.5rem">
        <ClientStepper request={request} />

        <StepMessage
          iconDone
          message={
            <Paragraph size="50" color="secondary">
              <Trans id="client.request.exchange.title">
                Your service is confirmed. You will be notified when your new item is available.
              </Trans>
            </Paragraph>
          }
        />

        <Stack gap={isMobile ? '1rem' : '1.5rem'}>
          <PickupPointInfo request={request} />
          <ClientArticlesList request={request} showPrice showArticleComment />
        </Stack>
      </Stack>
    </BrandRequestMainContent>
  );
};

export default Exchange;
